import { makeAutoObservable } from 'mobx';
import { PRESENTER_SLIDES_ASSET_RADIX } from '../../../../constans/presenter-constansts';

interface IProperty {
    name: string;
    value: string;
}

class AssetInPropertiesHolder {
  constructor (private properties: IProperty[]) {
    makeAutoObservable(this);
  }

  public getAssetId (): number | void {
    const assetProperty = this.properties.filter(x => x.name === 'assetId')[0];
    if (assetProperty) {
      return parseInt(assetProperty.value, PRESENTER_SLIDES_ASSET_RADIX);
    }
  }

  public setAssetId (value: number): void {
    const assetProperty = this.properties.filter(x => x.name === 'assetId')[0];

    // to avoid failures on null
    const stringifyValue = value ? value.toString(PRESENTER_SLIDES_ASSET_RADIX) : '';
    if (assetProperty) {
      assetProperty.value = stringifyValue;
    } else {
      this.properties.push({
        name: 'assetId',
        value: stringifyValue,
      });
    }
  }

  public getCuePointId (): string {
    const cuePointId = this.properties.filter(x => x.name === 'cuePointId')[0];
    return cuePointId ? cuePointId.value : '';
  }
}

export { AssetInPropertiesHolder };
